import { render, staticRenderFns } from "./we-header.vue?vue&type=template&id=97385398&scoped=true&"
import script from "./we-header.vue?vue&type=script&lang=js&"
export * from "./we-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97385398",
  null
  
)

export default component.exports